import React from 'react';
import { Redirect } from 'react-router-dom';
import paths from 'pages/Router/paths';

import { useFormatMessage } from 'hooks';

const Home = () => (
  <>
    <Redirect to={paths.STATIONS} />

    <section className="hero is-hero-bar">
      <div className="hero-body">
        <h1 className="title">{useFormatMessage('Home.home')}</h1>
      </div>
    </section>

    <section className="section is-main-section">
      {useFormatMessage('Home.content')}
    </section>
  </>
);
export default Home;
